import * as React from "react";
import model from "./locations/locations_model";
import {GoBackArrow} from "../go_back_forward_arrow";

const GroupSeparator = (props: {text: string, withBack?: boolean}) => {
    const back = <GoBackArrow backAction={model.backState} running={false}/>
    return <li className='searchEverywhere__group'>{props.withBack ? back : null}{props.text}</li>;
};

export default GroupSeparator;